import React, { forwardRef, InputHTMLAttributes } from 'react';

import clsx from 'clsx';

import {
  switchWrapper,
  hiddenInput,
  switchOuterWrapper,
  switchTrack,
  switchThumb,
} from './Switch.css';
import { Flex } from '../Flex';
import { Text } from '../Text';

export interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  label?: React.ReactNode;
}

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(
  ({ label, checked, disabled, className, onChange, ...props }, ref) => {
    return (
      <label className={clsx(switchWrapper, className)}>
        <input
          ref={ref}
          type="checkbox"
          role="switch"
          className={hiddenInput}
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          {...props}
        />
        <Flex
          direction="column"
          align="start"
          className={switchOuterWrapper({ disabled: disabled || false })}
        >
          <div
            className={switchTrack({
              checked: checked || false,
              disabled: disabled || false,
            })}
          >
            <div
              className={switchThumb({
                checked: checked || false,
                disabled: disabled || false,
              })}
            />
          </div>
        </Flex>
        {label &&
          (typeof label === 'string' ? (
            <Text textStyle="14_400" color="semanticPrimary">
              {label}
            </Text>
          ) : (
            label
          ))}
      </label>
    );
  },
);

Switch.displayName = 'Switch';
